import React from "react";
import { useWallet } from "../hooks/useWallet";
import { WalletStatus } from "../store/slices/walletSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import { ButtonVariant } from "../config/colors";
import Loader from "../pages/chat/components/Loader";

interface WalletActiveRouteProps {
    children: React.ReactNode;
    outsidePadding?: boolean;
    loaderIfNotSynced?: boolean;
}

export const WalletActiveRoute: React.FC<WalletActiveRouteProps> = ({ children, outsidePadding = true, loaderIfNotSynced = false }) => {
    const { status } = useWallet();
    const navigate = useNavigate();

    if (status === WalletStatus.OTHER_WALLET_ACTIVE) {
        return (
            <div className={`flex flex-col items-center justify-center gap-6 ${outsidePadding ? 'p-8' : ''} h-full`}>
                <div className="flex flex-col gap-4 text-center max-w-md">
                    <h2 className="text-xl font-semibold text-brand-orange">
                        Wallet Not Initialized
                    </h2>
                    <p className="text-sm opacity-80">
                    Please create a new wallet or restore an existing one to use this feature.
                    </p>
                </div>
                <div className="flex gap-3">
                    <Button
                        variant={ButtonVariant.primary}
                        onClick={() => navigate("/home/wallet")}
                    >
                        Go to Wallet
                    </Button>
                </div>
            </div>
        );
    }

    if(loaderIfNotSynced && status !== WalletStatus.ACTIVE) {
        return <Loader small />;
    }

    return <>{children}</>;
};
